if (window.matchMedia("(max-width: 899px)").matches) {
  jQuery(document).ready(function ($) {
    var contentPlacement = $("#topbar").position().top + $("#topbar").height();
    $("#PageContainer").css("padding-top", contentPlacement);
  });
}
if(document.getElementById("topbar") !== null) {
  jQuery(document).ready(function ($) {
    var contentPlacement = $("#topbar").position().top + $("#topbar").height();
    var TopNav = $("#TopNav").position().top + $("#TopNav").height();
    var NavHeight = $("header").position().top + $("header").height();
    $(".subnav-mega").css("top", contentPlacement + TopNav );
  });
}